import { createElement, isValidElement } from "react";
import toast from "react-hot-toast";
import ToastCard from "../components/ToastCard/ToastCard.jsx";

// message: рядок / JSX (заголовок) або { title, description }
// options: { id, duration, actions: [{ label, onClick, variant }], onClose (клік по хрестику) } — id дозволяє замінити/закрити сповіщення через toast.dismiss(id)
export const showToast = (message, type = "default", options = {}) => {
  const { actions, onClose, ...toastOptions } = options;
  const { title, description } =
    message &&
    typeof message === "object" &&
    !Array.isArray(message) &&
    !isValidElement(message)
      ? message
      : { title: message };

  return toast.custom(
    t =>
      createElement(ToastCard, {
        t,
        title,
        description,
        type,
        actions,
        onClose,
      }),
    { duration: 8000, position: "top-center", ...toastOptions }
  );
};
